export enum ServiceFrequencyEnum {
  ONE_TIME = 'onetime',
  REPEAT = 'repeat',
}
